import Rest from "./BaseRest";
import DjangoRest from "./DjanoBaseRest";

const resource = "schedules";
export default {
  FetchSchedule(id) {
    return Rest.get(`${resource}/${id}`);
  },
  StoreSchedule(schedule) {
    return Rest.post(`${resource}`, schedule);
  },
  UpdateSchedule(schedule) {
    return Rest.put(`${resource}/${schedule.id}`, schedule);
  },
  DestroySchedule(id) {
    return Rest.delete(`${resource}/${id}`);
  },
  FetchRecareEligibles() {
    return DjangoRest.get("recare_eligibles");
  },
  FetchMembersWithoutRedemptions() {
    return DjangoRest.get("new_members_without_redemptions");
  },
  CreateSchedule (schedule) {
    return DjangoRest.post("create_schedule/", schedule);
  },
  FetchCounters() {
    return DjangoRest.get(`${resource}/schedules_count/`);
  },
};
